(function() {
	angular
		.module('main')
		.controller('ContactFormController', ContactFormController);

	ContactFormController.$inject = [
		'$scope',
		'$http',
		'$routeParams',
		'$location',
		'copyToClipboardService',
		'validationService',
		'messageService',
		'settingsService'
	];

	function ContactFormController(
		$scope,
		$http,
		$routeParams,
		$location,
		copyToClipboardService,
		validationService,
		messageService,
		settingsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			if ($routeParams.closedWithError) {
				messageService.showErrorFromBackend(
					$routeParams.title,
					$routeParams.message
				);
				$location.search({});
			}
			settingsService.timeFormatSettings.subscribe(data => {
				if (data.contactFormVersion === 'V1') {
					$scope.isNewContactFormAvailable = false;
					getContactFormData();
					$scope.isSaveSpinnningWheelActive = false;
				} else {
					$scope.isNewContactFormAvailable = true;
				}
			});
		});

		const newField = { name: '', label: '' };

		const defaultFields = [
			{
				label: '',
				isMultilined: false,
				fieldType: 'FIRST_NAME',
				name: 'First name',
				defaultLabel: 'Your name',
				mandatory: true
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'LAST_NAME',
				name: 'Last name',
				defaultLabel: 'Surname',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'EMAIL',
				name: 'Email',
				defaultLabel: 'Your email',
				mandatory: true
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'PHONE',
				name: 'Phone',
				defaultLabel: 'Your phone',
				mandatory: null
			},
			{
				label: '',
				isMultilined: true,
				fieldType: 'MESSAGE',
				name: 'Message (appears in client notes)',
				defaultLabel: 'Message (tell me more about your enquiry)',
				mandatory: null
			}
		];

		$scope.varList = [
			{
				label: '',
				isMultilined: false,
				fieldType: 'FIRST_NAME',
				name: 'First name',
				defaultLabel: 'Your name',
				mandatory: true
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'LAST_NAME',
				name: 'Last name',
				defaultLabel: 'Surname',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'EMAIL',
				name: 'Email',
				defaultLabel: 'Your email',
				mandatory: true
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'PHONE',
				name: 'Phone',
				defaultLabel: 'Your phone',
				mandatory: null
			},
			{
				label: '',
				isMultilined: true,
				fieldType: 'MESSAGE',
				name: 'Message (answer appears in lead notes)',
				defaultLabel: 'Message (tell us more about your enquiry)',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'OTHER',
				name: 'Other (answer appears in lead notes)',
				defaultLabel: 'One more question',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'JOB_TYPE',
				name: 'Job type*',
				defaultLabel: 'Choose your package',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'JOB_DATE',
				name: 'Main shoot date',
				defaultLabel: 'Your wedding date',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'JOB_LOCATION',
				name: 'Job location',
				defaultLabel: 'Where is your reception venue?',
				mandatory: null
			},
			{
				label: '',
				isMultilined: false,
				fieldType: 'ENQUIRY_SOURCE',
				name: 'Lead source (answer appears in lead notes)',
				defaultLabel: 'How did you hear about us?',
				mandatory: null
			}
		];

		$scope.defaultIntroductionMessage =
			"Please fill out the contact form below and I'll be in touch shortly.";

		$scope.defaultThanksMessage = 'Thank you for enquiring!';

		$scope.colorPicker = {
			backgroundColor: '#efefef',
			textColor: '#000000',
			buttonColor: '#5f6066'
		};

		$scope.font = {
			currentFont:
				'"Arial", "Arial", "Helvetica CY", "Nimbus Sans L", Sans-serif'
		};

		$scope.fontsArray = [
			{
				name: 'Arial',
				fontFamily:
					'"Arial", "Arial", "Helvetica CY", "Nimbus Sans L", Sans-serif'
			},
			{
				name: 'Comic Sans',
				fontFamily: '"Comic Sans MS", "Comic Sans MS", "Monaco CY", cursive'
			},
			{
				name: 'Courier New',
				fontFamily: '"Courier New", "Courier New", monospace'
			},
			{
				name: 'Georgia',
				fontFamily: '"Georgia", "Georgia", serif'
			},
			{
				name: 'Helvetica',
				fontFamily: '"Helvetica", "Arial", "Arial", "Nimbus Sans L", Sans-serif'
			},
			{
				name: 'Times New Roman',
				fontFamily: '"Times New Roman", "Times CY", "Nimbus Roman No9 L", Serif'
			},
			{
				name: 'Trebuchet MS',
				fontFamily: '"Trebuchet MS", "Helvetica CY", Sans-serif'
			},
			{
				name: 'Verdana',
				fontFamily: '"Verdana", "Geneva CY", "DejaVu Sans", Sans-serif'
			}
		];

		$scope.copy2Clipboard = copyToClipboardService.copy;

		$scope.openVariablesList = function(field) {
			$scope.uniqueVarList = fillVarOptionsList(
				field,
				$scope.varList,
				$scope.contactForm.fields
			);

			$scope.contactForm.fields.map(item => {
				item.showVariablesList = false;
			});
			field.showVariablesList = true;
		};

		function fillVarOptionsList(field, array1, array2) {
			let tmpList = [];

			if (field.fieldType && field.fieldType.length > 0) {
				tmpList = array1.filter(item => {
					if (item.fieldType === field.fieldType) {
						return angular.copy(item);
					}
				});
			} else {
				tmpList = [];
			}

			let i = 0,
				max = array1.length;
			for (; i < max; i += 1) {
				let found = false;
				if (array1[i].fieldType === 'OTHER') {
					tmpList.push(angular.copy(array1[i]));
				}
				let j = 0,
					max2 = array2.length;
				for (; j < max2; j += 1) {
					if (array1[i].fieldType === array2[j].fieldType) {
						found = true;
						break;
					}
				}
				if (found == false) {
					if (
						array1[i].fieldType !== 'EMAIL' &&
						array1[i].fieldType !== 'FIRST_NAME' &&
						array1[i].fieldType !== 'OTHER'
					) {
						tmpList.push(angular.copy(array1[i]));
					}
				}
			}

			return tmpList;
		}

		$scope.setVariable = function(field, variable, defaultLabel) {
			field.showVariablesList = false;
			field.questionText = angular.copy(variable.name);

			const varTmp = $scope.uniqueVarList.filter(
				item => item.fieldType === variable.fieldType
			)[0];

			if (field.label !== null) {
				field.label = varTmp.defaultLabel;
			}

			if (varTmp) {
				field.defaultLabel = varTmp.defaultLabel;
				field.fieldType = varTmp.fieldType;
			}
		};

		$scope.removeField = function(index) {
			if ($scope.contactForm.fields.length !== 1) {
				$scope.contactForm.fields.splice(index, 1);
				// $scope.changeAllIndexes();
			}
		};

		$scope.addNewField = function() {
			$scope.contactForm.fields.push(angular.copy(newField));
			$scope.contactForm.fields[$scope.contactForm.fields.length - 1].index =
				$scope.contactForm.fields.length;
		};

		$scope.changeOptIn = function(optIn) {
			$scope.contactForm.optInConsent = optIn;
		};

		$scope.filterData2Saved = function(resultType) {
			if (!$scope.contactForm || !$scope.contactForm.fields) {
				return '';
			}

			const tmpObj = angular.copy($scope.contactForm);

			const data2Save = {
				fields: tmpObj.fields,
				introductionMessage: tmpObj.introductionMessage,
				thanksMessage: tmpObj.thanksMessage || $scope.defaultThanksMessage,
				backgroundColor: $scope.colorPicker.backgroundColor,
				textColor: $scope.colorPicker.textColor,
				buttonColor: $scope.colorPicker.buttonColor,
				fontFamily: $scope.font.currentFont,
				optInConsent: tmpObj.optInConsent,
				optInConsentStatement: tmpObj.optInConsentStatement
			};

			let firstNameField = 0,
				emailField = 0;

			data2Save.fields = data2Save.fields.map(item => {
				if (!item.label) {
					item.label = item.defaultLabel;
				}

				if (!item.mandatory) {
					item.mandatory = null;
				}

				if (item.fieldType === 'FIRST_NAME') {
					firstNameField++;
				} else if (item.fieldType === 'EMAIL') {
					emailField++;
				}

				return {
					label: item.label,
					fieldType: item.fieldType,
					mandatory: item.mandatory
				};
			});

			if (resultType === 'preview') {
				const fieldsArray = tmpObj.fields.map(el => ({
					label: el.label,
					fieldType: el.fieldType
				}));
				const dataToEncode = {
					fields: fieldsArray,
					introductionMessage: tmpObj.introductionMessage,
					thanksMessage: tmpObj.thanksMessage || $scope.defaultThanksMessage
				};
				return encodeURI(JSON.stringify(dataToEncode));
			}

			if (firstNameField === 0) {
				toastr.error('First name cannot be deleted', 'Error');
				return false;
			}

			if (emailField === 0) {
				toastr.error('Email cannot be deleted', 'Error');
				return false;
			}

			return data2Save;
		};

		$scope.saveContactForm = function(callbackFunction) {
			if (!callbackFunction) {
				$scope.isSaveSpinnningWheelActive = true;
			}

			if (
				$scope.contactForm.optInConsent &&
				validationService.isStringEmpty(
					$scope.contactForm.optInConsentStatement
				)
			) {
				messageService.showToaster('e_3', 'general', 'Opt-in consent');
				$scope.isSaveSpinnningWheelActive = false;
				return false;
			}

			if ($scope.contactForm.$invalid) {
				$scope.isSaveSpinnningWheelActive = false;
				messageService.showToaster('e_0', 'contactForm');
				return false;
			}

			const data2Save = $scope.filterData2Saved();

			if (!data2Save) {
				$scope.isSaveSpinnningWheelActive = false;
				return false;
			}

			$http({
				method: 'POST',
				url: '/protected/rest/contactform',
				data: data2Save
			}).then(
				() => {
					getContactFormData(callbackFunction);
					toastr.success(
						'Your contact form has been saved.',
						"You've earned your black belt!"
					);
					$scope.isSaveSpinnningWheelActive = false;
				},
				() => {
					$scope.isSaveSpinnningWheelActive = false;
				}
			);
		};

		$scope.previewGetCode = function() {
			$scope.previewEmbedCodeSubmited = false;
			$('#previewEmbedCodeModal').modal('show');
		};

		$scope.getURLContactForm = function() {
			if ($scope.contactForm && $scope.contactForm.companyAddress) {
				const originHref = `${window.location.origin}/`;
				let tmpContactUrl = '';
				tmpContactUrl += originHref;
				tmpContactUrl += $scope.contactForm.companyAddress;
				tmpContactUrl += '/contact';
				$scope.contactForm.contactUrl = tmpContactUrl;
			}

			$('#getURLModal').modal('show');
		};

		$scope.getEmbedCode = function() {
			const openModal = $('.modal.in');

			if (openModal.length > 0) {
				openModal
					.hide()
					.modal('hide')
					.on('hidden.bs.modal', function(e) {
						$scope.getEmbedCode();
						$(this).off('hidden.bs.modal');
					});

				return false;
			}

			const originHref = window.location.origin;
			let iframeSuffix = '';

			const hostTest = 'https://stdn.pp.ua';
			const hostLocal = 'http://localhost';
			const hostLocalNazar = 'https://nazar.stdn.pp.ua';
			const hostLocalVlad = 'https://vlad.stdn.pp.ua';

			if (originHref === hostTest) {
				iframeSuffix += '&test';
			} else if (originHref.includes(hostLocal)) {
				iframeSuffix += '&local';
			} else if (originHref.includes(hostLocalNazar)) {
				iframeSuffix += '&localNazar';
			} else if (originHref.includes(hostLocalVlad)) {
				iframeSuffix += '&localVlad';
			}

			let iFrameHeight = 300;

			$scope.contactForm.fields.map(el => {
				if (el.isMultilined) {
					iFrameHeight += 160;
				} else {
					iFrameHeight += 74;
				}
			});

			let tmlCode = '';
			tmlCode += `<iframe width="100%" height="${iFrameHeight}" src="`;
			tmlCode += originHref;
			tmlCode +=
				'/resources/' + 'dist/pages/public/contact_form_settings.html?company='; // Don`t change this path
			tmlCode += $scope.contactForm.companyAddress;
			tmlCode += iframeSuffix;
			tmlCode += '" frameborder="0" allowfullscreen></iframe>';

			$scope.contactForm.contactEmbedCode = tmlCode;
			$scope.$evalAsync();

			$('#getEmbedCodeModal')
				.modal('show')
				.on('shown.bs.modal', function() {
					$(this)
						.find('textarea')
						.focus();
				});
		};

		$scope.changeAllIndexes = function() {
			$scope.contactForm.fields.forEach((item, i) => {
				item.index = i + 1;
			});
		};

		$scope.setMandatory = function(fields) {
			fields.map(field => {
				if (field.fieldType === 'FIRST_NAME' || field.fieldType === 'EMAIL') {
					field.mandatory = true;
				} else {
					!field.mandatory;
				}
			});
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Contact Form' }
		];

		$scope.isSafari =
			Object.prototype.toString
				.call(window.HTMLElement)
				.indexOf('Constructor') >= 0;

		function getContactFormData(callbackFunction) {
			$http({
				method: 'GET',
				url: '/protected/rest/contactform'
			}).then(
				result => {
					$scope.isSaveSpinnningWheelActive = false;
					if (result.data) {
						if (result.data.optInConsent === null) {
							result.data.optInConsent = false;
						}
						$scope.contactForm = result.data;
					} else {
						$scope.contactForm = {};
					}
					fillContactFormData(callbackFunction);
				},
				result => {
					$scope.isSaveSpinnningWheelActive = false;
					$scope.contactForm = {};
				}
			);
		}

		function fillContactFormData(callbackFunction) {
			if ($scope.isNewContactForm) {
				delete $scope.isNewContactForm;
			}

			if (!$scope.contactForm.fields) {
				$scope.contactForm.fields = angular.copy(defaultFields);
				$scope.isNewContactForm = true;
			} else {
				$scope.contactForm.fields.map(item => {
					const varTmp = $scope.varList.filter(v => {
						if (v.fieldType === item.fieldType) {
							return v;
						}
					})[0];

					if (varTmp) {
						item.name = varTmp.name;
						item.defaultLabel = varTmp.defaultLabel;
					}
				});
			}

			const originHref = `${window.location.origin}/`;
			if ($scope.contactForm.companyAddress) {
				let tmpContactUrl = '';
				tmpContactUrl += originHref;
				tmpContactUrl += $scope.contactForm.companyAddress;
				tmpContactUrl += '/contact';

				$scope.contactForm.contactUrl = tmpContactUrl;
			}

			if ($scope.contactForm.backgroundColor) {
				$scope.colorPicker.backgroundColor = $scope.contactForm.backgroundColor;
			}

			if ($scope.contactForm.textColor) {
				$scope.colorPicker.textColor = $scope.contactForm.textColor;
			}

			if ($scope.contactForm.buttonColor) {
				$scope.colorPicker.buttonColor = $scope.contactForm.buttonColor;
			}

			if ($scope.contactForm.fontFamily) {
				$scope.font.currentFont = $scope.contactForm.fontFamily;
			}

			if (callbackFunction) {
				callbackFunction();
			}
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/contactFormController.js